import React from 'react';
import MenuContainer from '../../components/HomePage/MenuContainer/MenuContainer';
import './HomePage.scss'


function HomePage(props) {
    return (
        <div className='homepage'>
            <MenuContainer/>
        </div>
    );
}

export default HomePage;